import { Pipe, PipeTransform } from '@angular/core';

import { UtilsPcvizService } from '@mirage-projects/cw-pcviz-core';

@Pipe({
    name: 'geoidName',
    standalone: false,
})
export class GeoidNamePipe implements PipeTransform {
    constructor(private utilsService: UtilsPcvizService) {}

    async transform(code: string | undefined | null): Promise<string> {
        if (!code) {
            return '';
        }
        const result = await this.utilsService.getCRSUtils().findGeoidsByID(code);

        return result[0].description;
    }
}
